<template>
<a @mousedown="fileSelect" @click.prevent class="upload-file" :class="{'selected-file':selected}" attached="true" contenteditable="false" draggable="true">{{linkText}}</a>
</template>

<script>
import NodeHelpers from "@/../submodules/vue-base/tiptap/common/NodeHelpers";
import {
    Selection,
    NodeSelection,
	TextSelection,
} from "prosemirror-state"
export default {

    mixins: [NodeHelpers],

    props: ['node', 'updateAttrs', 'view', 'getPos', 'editor', 'selected'],

    name: "UploadFile",

    methods: {
        fileSelect(event) {

			

            if (this.isAndroid() && this.editor.state.selection instanceof TextSelection) {
                //fix for android jank
                //to prevent android from scrolling us to 
                //previous cursor position when we select a node
                //we will move the cursor right next to the node right before
                //we select it

                //this fix doesn't cause problems for other platforms if we get a false positive
                //it's only necissary in android though hence our this.isAndroid()

                var tr = this.editor.state.tr;
                tr = tr.setSelection(new TextSelection(tr.doc.resolve(this.getPos() - 2), tr.doc.resolve(this.getPos() - 2)));
                this.editor.view.dispatch(tr);
            }

            if(this.isMobile()){
				event.preventDefault();
            	this.editor.blur();
			}

            var temp = this;

            setTimeout(function () {
                var resolvedPos = temp.view.state.doc.resolve(temp.getPos())

                var nodeSelect = new NodeSelection(resolvedPos);

                temp.view.dispatch(temp.view.state.tr.setSelection(nodeSelect));
            }, 0)

        }
    },

    computed: {
        linkText() {
            return this.node.attrs.linkText;
        },
        href() {
            return this.node.attrs.href;
        }
    }

}
</script>
